import React from 'react';

interface CountdownScreenProps {
  message: string;
  secondsLeft: number;
}

const CountdownScreen: React.FC<CountdownScreenProps> = ({ message, secondsLeft }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center">
        <div className="text-9xl mb-8 animate-bounce">
          {message === 'GO!' ? '🚀' : '⏱️'}
        </div>
        <h1 className="text-8xl md:text-9xl font-black text-white mb-6 drop-shadow-2xl animate-pulse">
          {message}
        </h1>
        <p className="text-3xl md:text-4xl text-white/90 font-bold drop-shadow-lg">
          Game starting...
        </p>
        {secondsLeft > 0 && message !== 'GO!' && (
          <div className="mt-8">
            <div className="text-6xl font-black text-white/80">
              {secondsLeft}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountdownScreen;
